import { ADD_NEW_POI, REM_NEW_POI, RESET_NEW_POI } from "../../actionTypes/actionsTypes";
import { AppNoApiAction } from "../../types";

export interface NewPoiState {
    newPoi: Array<string>
}

// Define an initial state value for the app
const initialState: NewPoiState = {
    newPoi: []
}


function NewPoiReducer(state = initialState, action: AppNoApiAction) {
    // Reducers usually look at the type of action that happened
    // to decide how to update the state

    const roll = action.data as string;
    const pois = state.newPoi;
    switch (action.type) {
        case ADD_NEW_POI:
            
            if(pois.indexOf(roll) === -1){
                pois.push(roll)
            }
            return {
                ...state,
                newPoi: pois
            }
        case REM_NEW_POI:
            return {
                ...state,
                newPoi: state.newPoi.filter(e => e !== roll)
            }
        case RESET_NEW_POI:
            return {
                ...state,
                newPoi: []
            }
        default:
            return state
    }
}

export default NewPoiReducer;